module.exports = __webpack_public_path__ + "img/mobileiot7.314aec2f.png";